import { useEventStore } from "@/event";
import { eventRepository } from "@/event/integration/game/eventCollectableRepository";
import { ResourceType } from "@/game/entities/config/resources";

export function appendPassiveEventiumToOfflineAccumulator(
	offlineTickAccumulator: Partial<Record<ResourceType, number>>,
): void {
	if (!useEventStore().isActive) return;

	const passive = eventRepository.getPassiveEventium();
	offlineTickAccumulator[ResourceType.EVENTIUM_INCOME] =
		(offlineTickAccumulator[ResourceType.EVENTIUM_INCOME] || 0) + passive;
	offlineTickAccumulator[ResourceType.EVENTIUM] =
		(offlineTickAccumulator[ResourceType.EVENTIUM] || 0) + passive;
}

export function extendAccumulatorKeysWithEventiumIfActive(
	keys: ResourceType[],
): ResourceType[] {
	if (!useEventStore().isActive) return keys;
	return [...keys, ResourceType.EVENTIUM_INCOME, ResourceType.EVENTIUM];
}
